export default __webpack_public_path__ + "static/media/Remodeling.d27cb6b6.JPG";